<template>
    <form v-if="editItem" autocomplete="off" class="">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Quick and Easy Application Process. </h4>
            </div>
            <div class="card-body">
                <div class="">
                    <div v-if="hasRequirements">
                        <requirement-section-form class="mb-4"
                            ref="requirementSection"
                            :requirements="editItem.requirements"
                        />
                    </div>
                    <div >
                        <p class="mb-3">
                            Please confirm your interest by accepting the following conditions below:
                        </p>
                        <div class="form-check mb-4">
                            <input v-model="form.data_collection" class="form-check-input" type="checkbox" id="flexCheckDataCollection">
                            <label class="form-check-label" for="flexCheckDataCollection">
                                By checking this box, I agree that the information and document provide in my acccount in this portal is true and correct.
                            </label>
                        </div>
                        <div class="form-check mb-4">
                            <input v-model="form.employment_status_condition" class="form-check-input" type="checkbox" id="flexCheckRefundCondition">
                            <label class="form-check-label" for="flexCheckRefundCondition">
                                By checking this box, I declare that I am currently unemployed. I understand that if this is found to be false, I may be sanctioned by the Government of Akwa Ibom State and dismissed immediately.
                            </label>
                        </div>
                        <div v-if="editItem.category_id" class="form-check">
                            <input v-model="form.same_cateogry_condition" class="form-check-input" type="checkbox" id="flexCheckBeneficialCondition">
                            <label class="form-check-label" for="flexCheckBeneficialCondition"> 
                                By checking this box, I acknowledge that after applying for this opportunity <strong class="text-uppercase">({{ editItem.title }})</strong>, I will NOT be eligible to apply for any other job opportunity within the same category <strong class="text-uppercase">({{ editItem.category.title }})</strong>.
                            </label>
                        </div>      
                        <div v-if="errorMessage" class="mt-4">
                            <CommonPageErrorMessage :errorMessage="errorMessage" @clearError="() => { errorMessage = null }" />
                        </div>                      
                        <div class="d-grid d-sm-flex pt-5 gap-4">
                            <router-link :to="`/open-opportunities/${editItem.id}`" class="btn btn-dark w-100" >Cancel</router-link>
                            <button @click="confirm()" class="btn btn-primary w-100 mb-2 mb-sm-0"  type="button" > Submit Applicantion</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers, requiredIf, sameAs } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import RequirementSectionForm from './RequirementSectionForm.vue'

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        RequirementSectionForm
    },
    props:{
        editItem:{
            type: Object,
            default: null
        },
    },
    data(){
        return{
            form: {
                data_collection: false,
                employment_status_condition: false,
                same_cateogry_condition: false
            },

            errorMessage: null
        }
    },
    validations() {
        return {        
            form:{
                data_collection: {
                    sameAs: helpers.withMessage("You must confirm that the information provided in your account is true and accurate.",
                        sameAs(true)
                    )
                },
                employment_status_condition: {
                    sameAs: helpers.withMessage("You must confirm that you are currently unemployed and accept the related terms.",
                        sameAs(true)
                    )
                },
            },
        }
    },
    computed: {
        hasRequirements(){
            return this.editItem.requirements.length > 0 ? true : false
        },
    },
    methods:{
        async confirm() {
            this.errorMessage = null;

            if(this.hasRequirements){
                const requirementValid = await this.$refs.requirementSection.validate();
                if (!requirementValid) {
                    this.alertError("Please complete all required requirements.");
                    return;
                }
            }

            const result = await this.v$.$validate();
            if (!result) {
                this.alertError(this.v$.$errors[0].$message);
                return;
            }
            const confirmResult = await this.confirmAction({
                html: "<span>You are about to submit your application. Are you ready to proceed?</span>",
            });

            if (confirmResult.value) {
                this.submitData();
            }
        },
        submitData(){
            let payload = { ...this.form };
            payload.opportunity_number = this.editItem.friendly_id;

            payload.requirements = this.hasRequirements 
                ? this.$refs.requirementSection.getPayload() 
                : [];

            this.$store.dispatch("changeLoaderValue",true)
            this.$http.post(`/opportunities/${this.editItem.id}/apply`, 
                payload
            ).then(response => {
                this.$store.dispatch("changeLoaderValue", false)
                this.resetForm()
                if(response.data.success){
                    this.$emit('formSubmitted', response.data)
                    this.resetForm()
                } else {
                    if (response.data.message) { this.errorMessage = response.data.message }
                }
            })
    
        },
        resetForm(){
            this.v$.$reset()
            this.$emit("closeMe")
        },
    },
}
</script>